import DOMPurify from 'dompurify'

/** For HTML the backend stores as typed (statement bodies, editor comments) before it is rendered. */
export function sanitizeHtml(html: string | null | undefined): string {
  return html == null || html === '' ? '' : DOMPurify.sanitize(html)
}
